<template>
<div class="body">
  <div class="d-flex">
        <div class="col-lg-3">
          <div class="card menu-left">
            <div class="menu-left-img">
             <img class="img text-center" :src="dataImgVistoria.fotoPrincipal != null ? 'data:image/jpeg;base64,' + dataImgVistoria.fotoPrincipal : imgSemImg">
            </div>
            <div :style="{background: status.Cor}" class="text-center-status">
              <div class="msgStatus"  :style="{color: status.CorTexto }">{{status.Mensagem}}</div>
            </div>
            <div class="footerLf mt-4 d-flex">
              <div class="col-md-5">
                <img class="imgObra" src="https://static.zopone.com.br/img/survey/IlustracaoObra.svg">
              </div>
              <div class="col-md-8">
                <p class="codigoObra">CÓDIGO OBRA</p>
                <p class="codigoObraComputed">{{dataDetails.codigoObra}}</p>
                <p class="clienteLf">{{dataDetails.obraNome  == null ? "N/D" : dataDetails.obraNome}}</p>
              </div>
            </div>
            <div class="bodylf">
              <div class="mt-2 ml-3">
              <p class="infoLf">Cliente</p>
              <p class="infoLfInput">{{dataDetails.responsavel == null ? 'N/D' : dataDetails.responsavel}}</p>
              </div>
              <div class="mt-2 ml-3">
                <p class="infoLf">Nº do Contrato</p>
                <p class="infoLfInput">{{dataDetails.numeroContrato == null ? 'N/D' : dataDetails.numeroContrato}}</p>
              </div>
              <div class="mt-2 ml-3">
                <p class="infoLf">Data da Vistoria</p>
                <p class="infoLfInput">{{dataDetails.dataVistoriaFormatadaNotHour }}</p>
              </div>
              <div class="mt-2 ml-3">
                <p class="infoLf">Técnico Responsável:</p>
                <p class="infoLfInput">{{dataDetails.nome == null ? 'N/D' : dataDetails.nome}}</p>
              </div>
              <div class="mt-2 ml-3">
                <p class="infoLf">Supervisor</p>
                <p class="infoLfInput">{{dataDetails.coordenador == null ? 'N/D' : dataDetails.coordenador}}</p>
              </div>
               <div class="mt-2 ml-3">
                <p class="infoLf">Colaborador</p>
                <p class="infoLfInput">{{dataDetails.nomeColaborador == "" ? 'N/D' : dataDetails.nomeColaborador}}</p>
              </div>
                <div class="mt-2 ml-3">
                  <p class="infoLf">Técnico de seg. Responsável</p>
                  <p class="infoLfInput">{{dataDetails.responsavelSegurancaNome  == null ? 'N/D' : dataDetails.responsavelSegurancaNome }}</p>
              </div>
            </div>
          </div>
        </div>
         <div class="col-md-9">
           <b-tabs v-model="tabIndex">
    <b-tab :title="'Detalhes'">
      <template slot="title">
        <div><i class="fa fa-search text-third"></i><span class="d-md-down-none pl-1 text-third">Detalhes</span></div>
      </template>
          <div>
            <div class="card">
              <div class="head-right">
                  <button type="button" v-on:click="back" class="btn btn-third btn-sm ml-3"  style="margin-top: 13px; height:30.4px;width:27.4"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonBack"><i class="fas fa-arrow-circle-left"></i></button>
                  <h4 class="head-title-rg" style="margin-top: 15px;margin-left: 7px">Detalhe vistoria - {{dataDetails.codigoObra}}</h4>
                  <div class="ml-auto d-flex" style="gap: 1rem; justify-content: center; align-items: center; margin-right: 1rem;">
                    <div class="btnNotpdf" @click="generatePDF(dataDetails)" v-b-tooltip.hover :title="'Gerar PDF'" ><i class="fas fa-file-pdf" style="color: #595959; font-size: 15px;"></i></div>
                    <div class="btnNotAprovacao" v-if="dataDetails.statusvistoria != 2" v-on:click="AdicionarObs" v-b-tooltip.hover :title="'Reprovar vistoria'"><i class="fa fa-minus-circle" style="color: white; font-size: 15px;"></i></div>
                    <div class="buttonAprovar" v-if="dataDetails.statusvistoria != 3" v-on:click="openAprovedVistoria" v-b-tooltip.hover :title="'Aprovar vistoria'"><img class="mr-1" src="https://static.zopone.com.br/img/survey/IconeSim.svg" ></div>
                  </div>
              </div>
              <div class="mt-4">
                <div>
                    <h1 class="subtitle ml-4">Informações da Obra</h1>
                  <div class="d-flex mt-4 ml-2">
                    <div class="col-md-3">
                      <p class="infoLf">Cliente</p>
                      <p class="infoLfInput">{{dataDetails.responsavel == null ? 'N/D' : dataDetails.responsavel}}</p>
                    </div>
                    <div class="col-md-3">
                      <p class="infoLf">Nº do Contrato</p>
                      <p class="infoLfInput">{{dataDetails.numeroContrato == null ? 'N/D' : dataDetails.numeroContrato}}</p>
                    </div>
                    <div class="col-md-3">
                      <p class="infoLf">Tipo da Obra</p>
                      <p class="infoLfInput">{{dataDetails.obraNome == null ? 'N/D' : dataDetails.obraNome}}</p>
                    </div>
                    </div>
                    <hr class="ml-3 mr-3">
                </div>
                <div>
                    <h1 class="subtitle ml-4">Informações Gerais</h1>
                  <div class="d-flex mt-4 ml-2">
                    <div class="col-md-3">
                      <p class="infoLf">Data da Vistoria</p>
                      <p class="infoLfInput">{{dataDetails.dataVistoriaFormatadaNotHour}}</p>
                    </div>
                    <div class="col-md-3">
                      <p class="infoLf">Técnico Responsável</p>
                      <p class="infoLfInput">{{dataDetails.nome == null ? 'N/D' : dataDetails.nome}}</p>
                    </div>
                    <div class="col-md-3">
                      <p class="infoLf">Função</p>
                      <p class="infoLfInput">{{dataDetails.funcao == null ? 'N/D' : dataDetails.funcao}}</p>
                    </div>
                     <div class="col-md-3">
                      <p class="infoLf">Supervisor</p>
                      <p class="infoLfInput">{{dataDetails.coordenador == null ? 'N/D' : dataDetails.coordenador}}</p>
                    </div>
                    </div>
                    <hr class="ml-3 mr-3">
                </div>
                <div>
                    <div class="d-flex">
                      <div class="col-md-6">
                      <h1 class="subtitle">Atividades Critícas</h1>
                      <div class="mt-4 ml-1">
                        <div v-for="obj in atividadeCritica"  v-bind:key="obj.Id" class="CriticaFlex">
                          <img class="mb-2" src="https://static.zopone.com.br/img/survey/IconeSim (1).svg">
                          <p class="infoLfInput mt-2 ml-2">{{obj.atividadesCriticas.nome == null ? 'N/D' : obj.atividadesCriticas.nome}}</p>
                       </div>
                       <p v-if="atividadeCritica.length == 0" class="infoLfInput mt-2 ml-2">N/D</p>
                      </div>
                      </div>
                       <div class="col-md-6">
                      <h1 class="subtitle">APR'S</h1>
                      <div style="display:flex;">
                        <div class="cardapr card">
                          <div class="aprbody">
                             <img class="imgapr" :src="dataImgVistoria.fotoApr === null ? imgSemImg : 'data:image/jpeg;base64,' + dataImgVistoria.fotoApr">
                          </div>
                          <div class="footer-Apr">
                            <p class="descFotoApr text-center">APR</p>
                          </div>
                          <button v-if="dataImgVistoria.fotoApr != null " v-on:click="DawnloadApr(dataImgVistoria.fotoApr)" class="btn-dalownd-apr">
                            <i  class="ml-3 mt-3 fas fa-download" style="color: white;"></i>
                          </button>
                        </div>
                        <div class="cardapr card ml-2">
                          <div class="aprbody">
                             <img class="imgapr" :src="dataImgVistoria.fotoPt != null ? 'data:image/jpeg;base64,' + dataImgVistoria.fotoPt : imgSemImg">
                          </div>
                          <div class="footer-Apr">
                              <p class="descFotoApr text-center">PT</p>
                          </div>
                          <button v-if="dataImgVistoria.fotoPt != null " v-on:click="DawnloadApr(dataImgVistoria.fotoPt)" class="btn-dalownd-apr">
                            <i  class="ml-3 mt-3 fas fa-download"  style="color: white;"></i>
                          </button>
                        </div>
                        <div class="cardapr card ml-2">
                         <div class="aprbody">
                             <img class="imgapr" :src="dataImgVistoria.fotoDds != null ? 'data:image/jpeg;base64,' + dataImgVistoria.fotoDds : imgSemImg">
                          </div>
                          <div class="footer-Apr">
                              <p class="descFotoApr text-center">DDS</p>
                          </div>
                          <button v-if="dataImgVistoria.fotoDds != null " id="" v-on:click="DawnloadApr(dataImgVistoria.fotoDds)" class="btn-dalownd-apr">
                            <i  class="ml-3 mt-3 fas fa-download"  style="color: white;"></i>
                          </button>
                        </div>
                      </div>
                       <!-- <div class=" mt-4">
                         <div style="display: flex;">
                           <p class="infoLf mt-1">Cumprimento das APR's:</p>
                           <i v-if="dataDetails.aprAplicacao != 0" class="fas fa-times fa-2x ml-2 " style="color: red;margin-top:0px"></i>
                           <img v-if="dataDetails.aprAplicacao == 0" class="ml-2 mb-3" src="https://static.zopone.com.br/img/survey/IconeSim (1).svg">
                           <p :style="{color: dataStatusApr.color}" class="resulIpr ml-1 mt-1 infoLfInput">{{dataStatusApr.mensa}}</p>
                         </div>
                         <p v-for="obj in apr" v-bind:key="obj.id"  class="infoLfInput">{{obj.nome}}</p>
                         <p  class="infoLfInput" v-if="apr.length == 0">N/D</p>
                         <p class="infoLf">Observações:</p>
                         <p class="infoLfInput">{{dataDetails.observacaoApr}}</p>
                       </div> -->
                      </div>
                    </div>
                    <hr class="ml-3 mr-3">
                </div>
                 <div>
                    <h1 class="subtitle ml-4">Finalização</h1>
                    <div style="display:flex">
                     <img class="imgAss ml-3 mr-1" :src="'data:image/jpeg;base64,' + dataImgVistoria.assinatura ">
                     <div class="testeweee">
                       <!-- <p class="infoLfInput">{{dataDetails.nome == null ? 'N/D' : dataDetails.nome +  ' - SP/098878.7'}}</p> -->
                        <p class="infoLfInput">{{dataDetails.nome == null ? 'N/D' : dataDetails.nome }}</p>
                        <!-- <p class="infoLf">Técnico Segurança do Trabalho</p> -->
                        <p class="infoLf">Avaliador</p>
                        <p class="infoLfInput">Zopone Engenharia</p>
                     </div>
                    </div>
                    <hr class="ml-3 mr-3">
                </div>
                  <div v-if="dataDetails.statusvistoria == 2 " >
                    <div style="display:flex">
                      <h1 class="subtitle ml-4">Motivo Reprovação</h1>
                      <div class="btnNotMotivoReprova ml-2" v-on:click="AdicionarObs"><i class="fas fa-edit" style="color: rgb(255 96 0 / 92%);"></i></div>
                      <!-- <button v-on:click="AdicionarObs" class="btn btn-primary btn-sm ml-2"><i class="fas fa-edit"></i></button> -->
                    </div>
                    <div class="textareobs ml-4 mt-3">
                        <h1 class="infoLfInput ">{{dataDetails.obsReprovacao == "" ? 'N/D' : dataDetails.obsReprovacao}}</h1>
                    </div>
                    <hr class="ml-3 mr-3">
                </div>
              </div>
            </div>
          </div>
    </b-tab>
    <b-tab :title="'Equipamentos'">
      <template slot="title">
        <div><i :class="'fas fa-hard-hat'"></i><span class="d-md-down-none pl-1 text-third">{{'Equipamento'}}</span></div>
      </template>
      <SurveyPaintingComponent  v-on:back="back" v-on:AdicionarObs="AdicionarObs" v-on:changeStatus="changeStatus" v-on:imprimir="imprimir" ref="SurveyPainting"
      :dataEqp="dataDetails"
             ></SurveyPaintingComponent>
      <!-- <checklisttableComponent :dataCheckForm="dataDetails" v-on:changeStatus="changeStatus" v-on:AdicionarObs="AdicionarObs" :codigo="dataDetails.codigoObra" :idvistoria="dataDetails.id" v-if="dataDetails.utilizaEpi == false"></checklisttableComponent> -->
    </b-tab>
    <b-tab :title="'Equipamentos'">
      <template slot="title">
        <div><i class="far fa-image text-third"></i><span class="d-md-down-none pl-1 text-third">Imagens</span></div>
      </template>
      <!-- Tela de imagem -->
      <div class="card">
        <div class="head-right">
          <button type="button" v-on:click="back" class="btn btn-third btn-sm ml-3"  style="margin-top: 13px; height:30.4px;width:27.4"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonBack"><i class="fas fa-arrow-circle-left"></i></button>
          <h4 class="head-title-rg" style="margin-top: 15px;margin-left: 7px">Detalhe Supervisão - {{dataDetails.codigoObra}}</h4>
          <div class="ml-auto d-flex" style="gap: 1rem; justify-content: center; align-items: center; margin-right: 1rem;">
            <div class="btnNotpdf"  @click="generatePDF(dataDetails)" v-b-tooltip.hover :title="'Gerar PDF'" ><i class="fas fa-file-pdf" style="color: #595959; font-size: 15px;"></i></div>
            <div class="btnNotAprovacao" v-if="dataDetails.statusvistoria != 2" v-on:click="AdicionarObs" v-b-tooltip.hover :title="'Reprovar vistoria'"><i class="fa fa-minus-circle" style="color: white; font-size: 15px;"></i></div>
            <div class="buttonAprovar" v-if="dataDetails.statusvistoria != 3" v-on:click="openAprovedVistoria" v-b-tooltip.hover :title="'Aprovar vistoria'"><img class="mr-1" src="https://static.zopone.com.br/img/survey/IconeSim.svg" ></div>
          </div>
        </div>
        <div  class="boximg">
          <div class="d-flex" style="gap: 2rem; margin: 1rem 1rem 0 0;">
            <div style="display: flex; height: 100%; width: 100%; justify-content: initial; align-items: center; gap: 0.5rem;" >
              <input v-model="buttonAllImg" v-on:change="chekedAllimg" class="InputCheckAll"  type="checkbox">
              <div style="font-family: 'Segoe UI';">SELECIONAR TODOS</div>
            </div>
            <div style="display: flex; height: 100%; width: 100%; justify-content: end; align-items: center;" >
              <button :disabled="buttonDawloImg" :class="buttonDawloImg === false ? '' : 'button-downaload-ativo'" class="button-downaload" v-on:click="downloadImg" v-b-tooltip.hover :title="'Download'"><i  class="fas fa-download" style="color: white"></i></button>
            </div>
          </div>
          <div class="ml-2">
            <div v-for="obj in imgEqp" class="imgAll mt-4" v-bind:key="obj.Id">
              <input v-on:click="ChekedButtonAllImg" :value="obj" class="inputImg checkList" type="checkbox">
                <div class="card mt-2 card-outiline">
                  <div class="img-card">
                      <img class="imgAllInput" :src="'data:image/jpeg;base64,' + obj.midias.foto">
                  </div>
                  <div class="bodyimg">
                    <div style="width: 100%; height: 100%;">
                        <div style="display: flex; text-align: center; justify-content: center; height: 100%; align-items: center;">
                        <!-- <h1 class=" font-eq-card">Equipamento&nbsp;&nbsp;</h1> -->
                        <h1 class=" text-center font-eq-card">{{obj.vistoriaEpi.ca}}</h1>
                        <button class="btn-dalownd " v-on:click="DownOneImg(obj)">
                            <i  class="fas fa-download" style="color: rgb(68, 68, 68)"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
          </div>
        </div>
      </div>
    </b-tab>
  </b-tabs>
        </div>
        <pdfSurvey ref="surveyPdfQma"></pdfSurvey>
      </div>
      <b-modal  :title="'SUPERVISÃO - ' + dataDetails.codigoObra " size="md" hide-footer ref="modalObs">
        <template #modal-title>
            <div class="header-title">{{ 'SUPERVISÃO - ' + dataDetails.codigoObra  }}</div>
        </template>
        <div class="d-flex justify-content-center">
          <div class="col 12">
            <h1 class="text-center TituloModal">Relatório de reprovação da supervisão</h1>
          </div>
        </div>
        <div class="d-flex mt-4 justify-content-center">
          <div class="col 12">
           <textarea v-model="Observacao" class="textarea"></textarea>
          </div>
        </div>

        <div class="d-flex container_cancel_save">
              <div class="cancelar">
                  <button class="button-cancel" @click="hideModalObsReprovacao">CANCELAR</button>
              </div>
              <div class="criar">
                <button class="button-save" @click="ReprovarObs">REPROVAR</button>
              </div>
            </div>
      </b-modal>
      <b-modal ref="aprovedVistoria"
        size="md"
        centered
        title="Aprovar"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="rounded-bottom-1rem"
        content-class="rounded-1rem"
        >
        <template #modal-title>
            <div class="header-title">APROVAR VISTORIA</div>
        </template>
          <div class="container-new-template">
            <i class="fas fa-thumbs-up ml-2 text-secundary" style="color: green; text-align: center; font-size: 45px;width: 100%; margin: 1rem;"></i>

            <div class="font">Deseja proseguir com a aprovação da <strong style="font: bold;">vistoria</strong>?</div>

            <div class="d-flex container_cancel_save">
              <div class="cancelar">
                  <button class="button-cancel" @click="closeAprovedVistoria">CANCELAR</button>
              </div>
              <div class="criar">
                <button class="button-save" @click="changeStatus(3)">APROVAR</button>
              </div>
            </div>
          </div>
        </b-modal>
</div>
</template>
<script>
import formSurvey from './formSurvey.js'
export default formSurvey
</script>
<style>
.button-downaload {
  background: #008144;
  height: 40px;
  width: 40px;
  border: transparent;
  border-radius: 5px;
}
.button-downaload-ativo{
  background: #8a8a8a;
  height: 40px;
  width: 40px;
  border: transparent;
  border-radius: 5px;
}
.header-title{
  color: white;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Segoe UI';
}
.TituloModal {
  font-family: 'Segoe UI';
  font-size: 17px;
  color: #545454;
}
.btnNotMotivoReprova{
  margin-top: 0px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffeadc 0% 0% no-repeat padding-box;
  outline: none;
}
.btnNotAprovacao{
  margin-top: 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #b72121 0% 0% no-repeat padding-box;
  outline: none;
}
.btnNotpdf{
  margin-top: 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c9c9c9 0% 0% no-repeat padding-box;
  outline: none;
}
.buttonAprovar{
  margin-top: 0px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #008148 0% 0% no-repeat padding-box;
  outline: none;
}
.buttonAprovar:hover{
  background: rgb(7, 161, 72);
}
.text-center-status {
  height: 3rem;
}

.textarea{
  width: 100%;
  border: transparent;
  height: 200px;
}
.body{
  overflow-x: hidden;
}
.imgapr{
  height: 100%;
  width: 100%;
  border-radius: 10px 10px 0 0;
  object-fit: cover;
}
.textareobs{
  width: 98%;
}
.btn-dalownd-apr{
  position: absolute;
  height: 43px;
  width: 50px;
  color: none;
  background: none;
  border: none;
  bottom: 0px;
  right: 0px;

}
.menu-left{
  border-radius: 10px;
  height: 100%;
  width: 100%;
}
.obj-reprova{
  color: red;
  font-size: 24px;
  font-weight: bold;
}
.InputCheckAll{
  width: 20px;
  height: 20px;
  font-size: 25px;
  border-radius: 5px;
  margin-left: 3rem;
  outline: none;
}
.aprbody{
  height: 80%;
  width: 100%;
}
.cardapr{
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
}
.footer-Apr{
  height: 20%;
  background: #008144;
}
.img{
  width: 100%;
  border-radius: 10px 10px 0px 0px;
  height: 100%;
  object-fit: cover;
}
.descFotoApr{
  color: white;
  font-size: 16px;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.inputImg{
  width: 18px;
  margin-left: 175px;
  margin-top: 13px;
  position: absolute;
  z-index: 2;
  height: 32px;
  margin-top: 8px;
}
.msgStatus{
  font-family: 'Segoe UI';
  opacity: 1;
  font-weight: bold;
  height: 100%;
  font-size: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.font-eq-card{
  font-weight: bold;
  font-family: 'Segoe UI';
  font-size: 12px;
  color: rgb(68, 68, 68);
}

.btn-dalownd{
  border: none;
  background: none;
  position: absolute;
  margin-left: 140px  ;
}
.menu-left-img{
  height: 308px;
  width: 100%;
}
.img-card{
  width: 100%;
  height: 80%;
}
.menu-right{
  overflow-y: auto;
  height: 80vh;
}

.card-outiline{
  height: 200px;
  width: 200px;
  display: inline-block;
  border-radius: 10px 10px 0 0;
}

.status{
  width: 100%;
  color: white;
}
.bodyimg{
  background: #E4E5E6;
  color: black;
  height: 20%;
}
.imgObra{
  width: 100%;
  height: 82px;
  object-fit: contain;
}
.bodylf{
  height: 100%;
}
.codigoObra{
  font-size: 11px;
  font-family: 'Segoe UI';
  color: #4F4C4D;
  letter-spacing: 0px;
  margin-bottom: 0px;
}

.codigoObraComputed{
  margin-top: 0px;
  font: normal normal bold 25px/47px Segoe UI;
  color: #4F4C4D;
  letter-spacing: 0px;
  margin-bottom: 0px;
  opacity: 1;
}
.clienteLf{
  font-family: 'Segoe UI';
  font-size: 11px;
  letter-spacing: 0px;
  color: #4F4C4D;
  opacity: 1;
}

.infoLf{
  margin-bottom: 0px;
  text-align: left;
  letter-spacing: 0px;
  font-family: 'Segoe UI';
  color: #4F4C4D;
  font-size: 14px;
  opacity: 1;
}

.infoLfInput{
  text-align: left;
  letter-spacing: 0px;
  color: #4F4C4D;
  font-family: 'Segoe UI';
  font-size: 14px;
  opacity: 1;
  font-weight: bold;
}
.head-right{
  height: 59px;
  display: flex;
  width: 100%;
  background: #ECEFF1 0% 0% no-repeat padding-box;
  border: 1px solid #CFD8DC;
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
}
.head-title-rg{
  font: normal normal 600 16px/21px Segoe UI;
  letter-spacing: 0.24px;
  color: #008148;
  opacity: 1;
}

.btnPdf{
  margin-top: 0px;
  width: 40px;
  height: 40px;
  border: none;
  background: #DEDEDE 0% 0% no-repeat padding-box;
  outline: none;
  font-size: 20px;
}
.btnNot{
  font-size: 21px;
  margin-top: 0px;
  width: 40px;
  height: 40px;
  border: none;
  background: #DEDEDE 0% 0% no-repeat padding-box;
  outline: none;
}
.btnPdf:hover , .btnNot:hover{
  outline: none;
  background: rgb(98, 101, 102);
}
.subtitle{
  text-align: left;
  letter-spacing: 0px;
  font-family: 'Segoe UI';
  color: #008148;
  font-size: 18px;
  opacity: 1;
}
.CriticaFlex{
  display: flex;
}
.imgAss{

  width: 325px;
  height: 150px;
  object-fit: contain;
}
.testeweee{
 flex-flow: column;
}
.resulIpr{
  text-align: right;
  font-size: 20px;
  letter-spacing: 0px;
  opacity: 1;
}
.dropdown:focus{
outline: none;
}
/* .dropdown-menu:focus{
  outline: none;
} */

/* ------------------------------------- */
.green{
  color: white;
  width: 200px;
  background: green;
  border-radius: 3px;
}
.red{
  color: white;
   width: 200px;
  background: red;
  border-radius: 3px;
}

.blue{
  color: white;
  width: 200px;
  background: rgb(30, 30, 187);
  border-radius: 3px;
}
.yellow{
  color: white;
  width: 200px;
  background: rgb(168, 168, 23);
  border-radius: 3px;
}

.imgPdf{
  margin: 0px;
  width: 250px;
  height: 250px;
  object-fit: contain;
}
.tableBorde{
  margin-top: 50px;
  width: 90%;
  border: 5px;
  margin-left: 50px;
  border-color: black;
}
.thh1{
  margin: 0px;
  color: black;
}
.relatorio{
  width: 800px;
  height: 100px;
}
.infoPdf {
  font-size: 20px;
  color: black;
  font-weight: 900;
}
.tdEmpty{
  height: 40px;
}
.noPrint{
    display:none !important;
}
.teste{
  border-style: solid;
  border: 5px;
}
.imgAll {
margin-left: 40px;
border: red;
display: inline;
position: relative;
align-items: center;
float:left;

}
.imgAllInput{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px 10px 0 0;
}
.boximg{
  background-color: white;
  width: 100%;
  border: 1px solid #CFD8DC;
}
.container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1rem;
    column-gap: 10px;
   }
.button-cancel,
.button-save{
  margin-top: 1rem;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 170px;
  height: 35px;
  font-family: 'Segoe UI';
  font-size: 12px;
  font-weight: bold;
}
.button-cancel{
  background-color: #b60000;
  color: white;
}
.button-save{
  background-color: darkgreen;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/private/Survey/components/formSurvey/formsurvey.vue